<template>
<div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'ShippingMethodList' }">Shipping Methods</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
    ref="shipping_method"
    :rules="rules.shipping_method"
    :model="shipping_method"
    :label-position="label_position">

        <el-form-item label="Name" prop="name">
            <el-input v-model="shipping_method.name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
            <el-input v-model="shipping_method.description"></el-input>
        </el-form-item>
        <el-form-item label="Tracking URL" prop="tracking_url">
            <el-input v-model="shipping_method.tracking_url"></el-input>
        </el-form-item>
        <el-form-item label="Support E-Mail" prop="support_email">
            <el-input v-model="shipping_method.support_email"></el-input>
        </el-form-item>
        <el-form-item label="Support Number" prop="support_number">
            <el-input v-model="shipping_method.support_number"></el-input>
        </el-form-item>
        <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0" v-model="shipping_method.sort_order"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateShippingMethod('shipping_method')">Update</el-button>
        </el-form-item>

   </el-form>

  <pre v-if="config.debug">{{$data}}</pre>

</div>
</template>

<style>

</style>

<script>

    import Config from '@/store/Config.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Edit Shipping Method',
                page_slug: 'edit-shipping-method',
                label_position: 'top',
                loading: false,
                rules: {
                    shipping_method: {
                        name: [
                            {required: true, message: 'Please Enter Corporation Name', trigger: 'blur'}
                        ],
                        description: [
                            {required: true, message: 'Please Enter Description', trigger: 'blur'}
                        ],
                        tracking_url: [
                            {required: true, message: 'Please Enter URL', trigger: 'blur'},
                            {type: 'url', message: 'Please Enter Valid URL', trigger: 'blur'}
                        ],
                        support_email: [
                            {required: true, message: 'Please Enter E-Mail', trigger: 'blur'},
                            {type: 'email', message: 'Please Enter Valid E-Mail', trigger: 'blur'}
                        ],
                        support_number: [
                            {required: true, message: 'Please Enter Support Number', trigger: 'blur'},
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                            {type: 'integer', message: 'Please Enter Number', trigger: 'blur'}
                    ],
                    }
                },

                shipping_method: {
                    name: '',
                    description: '',
                    tracking_url: '',
                    support_email: '',
                    support_number: '',
                    sort_order: '',
                },
            };  
        },

        mounted: function() {
            const me = this;
            me.getShippingMethod();
        },

        methods: {
            getShippingMethod: function() {
                console.log('get shipping method function');
                const me = this;
                // start the loader
                me.loading = true;
                me.$http.get(me.config.api + 'shippingMethods/{id}', {params: {id : me.$route.params.id}}).then(
                    response => {
                        console.log('Success Getting Data')  
                        // get status
                        console.log(response.status);
                        // get status text
                        console.log(response.statusText);
                        // get body data
                        me.shipping_method = response.body.data;
                        me.loading = false;
                    }, response => {
                        // error callback
                        console.log('Error Getting Data');
                        // get status
                        console.log(response.status);
                        // get status text
                        console.log(response.statusText);
                        me.$notify({
                            title: 'Error',
                            message: response.statusText,
                            stype: 'error'
                        });
                        // end the loader
                        me.loading = false;
                    }
                );
            },

            updateShippingMethod: function(formName) {
                console.log('update shipping method function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                    if (valid) {
                        me.$http.put(me.config.api + 'shippingMethods/{id}', me.shipping_method, {params: {id : me.$route.params.id}}).then(
                        response => {
                            console.log('success putting data')  
                            console.log(response.status);
                            console.log(response.statusText);

                            me.getShippingMethod();

                            me.$notify({
                                title: 'Success',
                                message: 'The Shipping Method Was Updated',
                                type: 'success'
                            });
                        }, response => {
                            console.log('Error Getting Data');
                            console.log(response.status);
                            console.log(response.statusText);
                        });
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });   
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/shipping-methods/ShippingMethodEdit.vue